module.exports = __webpack_public_path__ + "7ef2d6d43546766c9ddf56f0bfa35bfa.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/guitar/12_B2.mp3
// module id = 70
// module chunks = 0